export default __webpack_public_path__ + "static/media/pricing_art_1.d78e15e8.png";